<template>
  <div>
    <div
      class="accelerate-loading"
      v-show="isShowLoading"
    >
      <div class="accelerate-loading-content">
        <img
          src="~assets/image/icon/loading-inter.svg"
          alt="loadingOut"
          class="loading-out"
        >
        <img
          src="~assets/image/icon/loading-out.svg"
          alt="loadingInt"
          class="loading-int"
        >
      </div>
      <p>
        <span>L</span> <span>o</span> <span>a</span> <span>d</span> <span>i</span> <span>n</span>
        <span>g</span><span>…</span>
      </p>
    </div>
    <div
      class="pop"
      v-if="isShowDialog&&!isShowLoading&&firstShow"
      :key="Math.random()"
    >
      <el-dialog
        custom-class="pop"
        :close-on-click-modal="false"
        :show-close="false"
        :close-on-press-escape="false"
        top="24vh"
        title="免责声明"
        :visible.sync="isShowDialog"
        width="30%"
        center
      >
        <span style="display:flex;text-indent:2em;line-height: 2">本产品数据来自用户实测和主动提交。测试结果和统计数据受网络状况、终端设备、检测时间、样本大小、统计方法等多种因素影响，仅供参考；测速网不承担任何直接或间接法律责任。本产品仅统计中国大陆地区的数据，不包括中国香港、中国澳门和中国台湾的数据。</span>
        <span
          slot="footer"
          class="dialog-footer"
          style="top: 10px"
        >
          <el-button
            type="primary"
            @click.stop="closeDialog"
          >同意本声明</el-button>
        </span>
      </el-dialog>
    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      centerDialogVisible: false,
      isShowLoading: false,
      firstShow: false,
      isShowDialog: false
    }
  },
  computed: {
    ...mapState(['loadding']),
    ...mapState('login', ['is_login', 'is_member'])
  },
  watch: {
    loadding: {
      handler(val, old) {
        const name = this.$store.state.navigation.name
        if (val[name] && val[name].length) {
          const isLoad = val[name].some(bool => {
            return bool === false
          })
          if (isLoad) {
            this.isShowLoading = true
          } else {
            this.isShowLoading = false
            if (sessionStorage.getItem('loginAlertShow')) {
              this.$loginDialog.open()
              sessionStorage.removeItem('loginAlertShow')
            }
            if (sessionStorage.getItem('goToMember') && this.is_login && !this.is_member) {
              this.$msgBox
                .showMsgBox({
                  content: '开通测速网大数据会员，可查看近3个月平台页面展示的所有数据',
                  cancelVal: '我再想想',
                  confirmVal: '立即开通'
                })
                .then(async val => {
                  // ...
                  this.$router.push({ path: '/pay-member' })
                })
                .catch(() => {
                  // ...
                  console.log('取消')
                })
              sessionStorage.removeItem('goToMember')
              sessionStorage.removeItem('memberLink')
            }
            if (sessionStorage.getItem('goToMember')&&sessionStorage.getItem('memberLink') && this.is_login && this.is_member) {
              this.$router.push(sessionStorage.getItem('memberLink'))
              sessionStorage.removeItem('goToMember')
              sessionStorage.removeItem('memberLink')
            }
            setTimeout(() => {
              this.firstShow = true
            }, 10)
          }
        }
      },
      deep: true
    },
    '$store.state.navigation.name': {
      handler(val, old) {
        if (sessionStorage.getItem('isLoadding')) {
          //弹过窗的页面不在弹
          this.isShowDialog = false
        } else {
          this.isShowDialog = true
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    closeDialog() {
      this.isShowDialog = false
      this.firstShow = false
      sessionStorage.setItem('isLoadding', true)
    }
  },
  mounted() {}
}
</script>

<style lang="less" scoped>
.fade-leave {
  opacity: 1;
}
.fade-leave-active {
  transition: all 1s;
}
.fade-leave-to {
  opacity: 0;
}

.accelerate-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.85);
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  z-index: 1000;

  .accelerate-loading-content {
    width: 144px;
    height: 146px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(0.8);

    .loading-out {
      width: 144px;
      height: 146px;
      position: absolute;
      left: 0;
      top: 0;
      animation: rotateAni 2s infinite;
    }
  }

  p {
    color: #fff;
    margin-top: 20px;
    margin-bottom: 0;
    font-size: 0;
    transform: scale(0.8);
    span {
      font-size: 30px;
      display: inline-block;
      height: 40px;
    }
  }
}

.pop {
  :deep(.el-dialog__wrapper) {
    line-height: 0.01;

    .el-dialog {
      background-color: rgba(11, 25, 66, 0.9);
      border: 1px solid #00d2fa;

      .el-dialog__body {
        padding-top: 10px;
        padding-left: 40px;
        padding-bottom: 5px;
        padding-right: 40px;
        color: white;
      }
    }

    .el-dialog__header {
      padding-top: 10px;

      .el-dialog__title {
        height: 5px;
        color: white;
      }
    }

    .el-dialog__footer {
      .dialog-footer {
        height: 15px;
      }
    }
  }
}

@keyframes rotateAni {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
